import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container, Row, Col, Button, Spinner, Alert } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from '../../backendClient';

const Heading = ({ title, subtitle, center }) => {
  return (
    <Container className={center ? 'text-center' : 'text-start'}>
      <h2 className="h2 font-weight-bold">{title}</h2>
      {subtitle && <p className="text-muted mt-2">{subtitle}</p>}
    </Container>
  );
};

const getStoredRedirect = () => {
  try {
    return JSON.parse(localStorage.getItem('IM_redirect') || 'null');
  } catch {
    return null;
  }
};

const AccessProcessing = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const incoming = location.state; 


  const {currentUser} = useSelector(state => state.user);
  const hasRun = useRef(false);

//   const redirectState = useMemo(() => {
//     return location.state || getStoredRedirect() || {};
//   }, [location.state]);



  const redirectState = useMemo(() => ({
    source: 'event',
    slug: incoming?.slug,
    eventId: incoming?.eventId ?? null,
    returnAfterLogin: `/single/${incoming?.slug}`,
    returnAfterRegister: `/single/${incoming?.slug}`,
    cost: incoming?.cost,
    title: incoming?.title,
    isLead: incoming?.isLead
  }), [incoming]);

  const [eventId, setEventId] = useState( redirectState.eventId || "");
  const [slug, setSlug] = useState(redirectState.slug || "");
  const [title, setTitle] = useState(redirectState.title || "");
  const [isLead, setIsLead] = useState(redirectState.isLead || false);  
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState('');



  

  const pageTitle = isLead
    ? 'Taking you to your ListRoom...'
    : 'Taking you to your Event Chat...';

  const pageSubtitle = isLead
    ? 'We are confirming your access and preparing your list room.'
    : 'We are confirming your access and opening your event chat.';


  useEffect(() => {
    if (!redirectState?.eventId) {
      navigate('/search', { replace: true });
      return;
    }

    localStorage.setItem(
      'IM_redirect',
      JSON.stringify(
        redirectState
      )
    );

    if (!currentUser) {
      navigate('/login', {
        replace: true, 
        state:
          redirectState,
      });
    }
  }, [currentUser, redirectState, navigate]);


    // fallback from localStorage redirect
useEffect(() => {
        if (!eventId || !slug) {
          try {
           const rs = JSON.parse(localStorage.getItem('IM_redirect') || 'null');
            if (rs?.eventId) setEventId(rs.eventId);
            if (rs?.slug) setSlug(rs.slug);
            if (rs?.isLead) setIsLead(rs.isLead); 
            if (rs?.title) setTitle(rs.title); 
          } catch {}
        }
      }, [eventId, slug]);



 const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  useEffect(() => {
    if (!currentUser) return;
    if (!eventId) return;
    if (hasRun.current) return;

    hasRun.current = true;

    const grantAccess = async () => {
      try {
        setStatus('processing');
        setError('');

        //**FOR TESTING CAN HALT Processing Page */
        //await wait(500);


        const res = await axios.post('/api/payments/freeAccess', {
            eventId
          });


        if (!res.data?.success) {
           throw new Error(res.data?.message || 'Could not grant access.');
         }

        /* SET SUCCESS IN EACH CASE **TO REMOVE**/ 
        setStatus('success');

        localStorage.removeItem('IM_redirect');

         setTimeout(() => {
            navigate( res.data.redirectUrl || `/single/${slug || ''}`, {
            replace: true,
            state: {
              paid: true,
            },
          });
        }, 500);

      } catch (err) {
        console.error('grant access error:', err);
        setStatus('error');
        setError(err.message || 'Something went wrong.');
      }
    };

    grantAccess();
  }, [currentUser, eventId, slug, isLead, navigate]);

  const retry = () => {
    hasRun.current = false;
    setStatus('processing');
    setError('');
  };

  return (
    <Container className="d-flex h-100 flex-column justify-content-center align-items-center text-center mt-3">
      <Row>
        <Col>
          {status === 'processing' && (
            <>
              <Spinner animation="border" variant="primary" className="mb-4" />
              <Heading center title={pageTitle} subtitle={pageSubtitle} />
              {title && <p className="text-muted mt-3 mb-0">{title}</p>}
            </>
          )}

          {status === 'success' && (
            <>
              <div className="mb-4 text-success" style={{ fontSize: '42px' }}>
                ✓
              </div>
              <Heading
                center
                title="Access confirmed"
                subtitle={isLead ? 'Opening your ListRoom now.' : 'Opening your Event Chat now.'}
              />
            </>
          )}

          {status === 'error' && (
            <>
              <Alert variant="danger" className="mb-4">
                {error}
              </Alert>

              <Heading
                center
                title="We couldn’t finish this automatically"
                subtitle="Try again, or go back to the offer page."
              />

              <Row className="mt-4">
                <Col className="d-flex justify-content-center gap-3">
                  <Button variant="primary" onClick={retry}>
                    Try Again
                  </Button>

                  <Button
                    variant="outline-primary"
                    onClick={() => navigate(slug ? `/single/${slug}` : '/search')}
                  >
                    Go Back
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default AccessProcessing;